"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CardClose = exports.CardHeader = exports.CardActions = exports.CardContent = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Fab = _interopRequireDefault(require("../Fab"));

var _arrowBack = _interopRequireDefault(require("../icons/arrow-back.svg"));

var _cross = _interopRequireDefault(require("../icons/cross.svg"));

require("./card.sass");

var Card = function Card(_ref) {
  var className = _ref.className,
      props = (0, _objectWithoutProperties2.default)(_ref, ["className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)('card', className)
  }, props));
};

var CardContent = function CardContent(_ref2) {
  var className = _ref2.className,
      props = (0, _objectWithoutProperties2.default)(_ref2, ["className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)('card-content', className)
  }, props));
};

exports.CardContent = CardContent;

var CardActions = function CardActions(_ref3) {
  var className = _ref3.className,
      justify = _ref3.justify,
      props = (0, _objectWithoutProperties2.default)(_ref3, ["className", "justify"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)('card-actions', {
      'card-actions--justify': justify
    }, className)
  }, props));
};

exports.CardActions = CardActions;

var CardHeader = function CardHeader(_ref4) {
  var className = _ref4.className,
      children = _ref4.children,
      onBack = _ref4.onBack,
      props = (0, _objectWithoutProperties2.default)(_ref4, ["className", "children", "onBack"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)('card-header', className, {
      'card-header--withBack': onBack
    })
  }, props), onBack && _react.default.createElement(_Fab.default, {
    mini: true,
    borderless: true,
    Icon: _arrowBack.default,
    onClick: onBack,
    className: "card-header-back"
  }), children);
};

exports.CardHeader = CardHeader;
CardHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.default.string,
  onBack: _propTypes.default.func
} : {};

var _ref6 = _react.default.createElement(_cross.default, null);

var CardClose = function CardClose(_ref5) {
  var className = _ref5.className,
      circle = _ref5.circle,
      props = (0, _objectWithoutProperties2.default)(_ref5, ["className", "circle"]);
  return _react.default.createElement("a", (0, _extends2.default)({
    className: (0, _classnames.default)('card-close', className, {
      'card-close--circle': circle
    })
  }, props), _ref6);
};

exports.CardClose = CardClose;
var _default = Card;
exports.default = _default;